import { render } from "./TileGameWrapper.vue?vue&type=template&id=288b92a1"
import script from "./TileGameWrapper.vue?vue&type=script&lang=js"
export * from "./TileGameWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__